type IconProps = {
    color?: string
}

export const DownloadIcon = ({ color = '#fff' }: IconProps) => (
    <svg width="26" height="28" viewBox="0 0 26 28" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <filter
                x="-9.3%"
                y="-61.5%"
                width="118.6%"
                height="223.1%"
                filterUnits="objectBoundingBox"
                id="downloadiconfilter"
            >
                <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur stdDeviation="3" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                <feColorMatrix
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
                    in="shadowBlurOuter1"
                    result="shadowMatrixOuter1"
                />
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1" />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
        </defs>
        <g filter="url(#downloadiconfilter)" transform="translate(-3 -1)" fill={color} fillRule="evenodd">
            <path d="M22.664 21H9.336a.324.324 0 01-.238-.098.324.324 0 01-.098-.238v-2c0-.088.033-.165.098-.23a.324.324 0 01.238-.098h13.328c.094 0 .174.032.239.098a.315.315 0 01.097.23v2a.324.324 0 01-.097.238.324.324 0 01-.239.098zm.243-10.758l-6.664 6.664A.432.432 0 0116 17a.432.432 0 01-.242-.094l-6.664-6.664c-.088-.088-.115-.213-.078-.375.057-.135.164-.203.32-.203H13V5.336c0-.094.033-.173.098-.238A.324.324 0 0113.336 5h5.328c.094 0 .174.033.239.098a.324.324 0 01.097.238v4.328h3.664c.157 0 .263.068.32.203.037.162.011.287-.077.375z" />
        </g>
    </svg>
)

export const UploadIcon = ({ color = '#fff' }: IconProps) => (
    <svg width="26" height="28" viewBox="0 0 26 28" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <filter
                x="-9.3%"
                y="-61.5%"
                width="118.6%"
                height="223.1%"
                filterUnits="objectBoundingBox"
                id="uploadiconfilter"
            >
                <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur stdDeviation="3" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                <feColorMatrix
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
                    in="shadowBlurOuter1"
                    result="shadowMatrixOuter1"
                />
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1" />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
        </defs>
        <g filter="url(#uploadiconfilter)" transform="translate(-3 -1)" fill={color} fillRule="evenodd">
            <path d="M22.664 5H9.336a.324.324 0 00-.238.098.324.324 0 00-.098.238v2c0 .088.033.165.098.23a.324.324 0 00.238.098h13.328a.324.324 0 00.239-.098.315.315 0 00.097-.23v-2a.324.324 0 00-.097-.238.324.324 0 00-.239-.098zm.243 10.758l-6.664-6.664A.432.432 0 0016 9a.432.432 0 00-.242.094l-6.664 6.664c-.088.088-.115.213-.078.375.057.135.164.203.32.203H13v4.328c0 .094.033.173.098.238a.324.324 0 00.238.098h5.328a.324.324 0 00.239-.098.324.324 0 00.097-.238v-4.328h3.664c.157 0 .263-.068.32-.203.037-.162.011-.287-.077-.375z" />
        </g>
    </svg>
)
